
import { GlobalConfig } from 'display/config'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

@Component
export default class Skeleton extends Vue {
	@GlobalConfig() enableAnimation!: boolean
}
